import Assets from './Assets';
import Hours from './Hours';
import Tag from './Tag';
import Localization from './Localization';
import OptionGroup from './OptionGroup';
import PriceLevel from './PriceLevel';
import GroupDependency from './GroupDependency';
import OptionDefault from './OptionDefault';

export default class Article {
	// tslint:disable-next-line:variable-name
	_id: string;
	availableHours?: Hours[];
	averageRating?: number;
	icon?: Assets;
	assets?: Assets;
	banner?: Assets;
	createdAt?: Date;
	defaults?: OptionDefault[];
	recommendations?: OptionDefault[];
	info?: Localization;
	shortDescription?: Localization;
	description?: Localization;
	groups?: OptionGroup[];
	isActive?: boolean;
	name: Localization;
	note?: string;
	number: string;
	counterArticle: string;
	masterId?: string;
	price: {
		$numberDecimal: number;
	};
	priceByType: {
		standard: {
			$numberDecimal: number;
		};
		preorder: {
			delivery: {
				$numberDecimal: number;
			};
			inside: {
				$numberDecimal: number;
			};
			takeAway: {
				$numberDecimal: number;
			};
		};
		terminal: {
			inside: {
				$numberDecimal: number;
			};
			takeAway: {
				$numberDecimal: number;
			};
		};
	};
	displayPrice: {
		$numberDecimal: number;
	};
	displayPriceByType: {
		standard: {
			$numberDecimal: number;
		};
		preorder: {
			delivery: {
				$numberDecimal: number;
			};
			inside: {
				$numberDecimal: number;
			};
			takeAway: {
				$numberDecimal: number;
			};
		};
		terminal: {
			inside: {
				$numberDecimal: number;
			};
			takeAway: {
				$numberDecimal: number;
			};
		};
	};
	priceLevels: PriceLevel[];
	rateable: boolean;
	sortOrder: number;
	tags?: Tag[];
	takeaway?: boolean;
	updatedAt?: Date;
	visible: boolean;
	optionNumber: string;
	isMappedArticle: false;
	groupDependencies: GroupDependency[];
	availability: {
		standard: boolean;
		preorder: {
			takeAway: boolean;
			inside: boolean;
			delivery: boolean;
		};
		terminal: {
			takeAway: boolean;
			inside: boolean;
		};
	};
	fsk: number;
	// only if child of optionGroup
	requirements: {
		min: number;
		max: number;
	} | null;
	hidden: boolean;
	isFromPrice = false;
}
